import {ICurrency} from "../../../store/reducers/fleetReducer/fleetReducerTypes";

/**
 * Форматирует цену с учетом особенностей валюты
 * Особое форматирование для INR (индийская рупия)
 */
export const DisplayFlyPrice = (price: number | null, currency: ICurrency | null, onRequestText?: string) => {
  if (price === null || price === 0) {
    return onRequestText || "On request";
  }

  const currencyName = currency?.name || '';
  
  // Округляем цену до 2 знаков после запятой для всех валют
  const roundedPrice = Math.round(price * 100) / 100;
  
  // Специальное форматирование для INR (индийская рупия)
  // INR использует индийскую систему нумерации: последние 3 цифры, затем группы по 2
  // Проверяем как точное совпадение, так и регистронезависимое
  if (currencyName.toUpperCase() === 'INR') {
    const priceStr = Math.round(roundedPrice).toString();
    if (priceStr.length <= 3) {
      return `${priceStr} ${currencyName}`;
    }
    
    // Берем последние 3 цифры
    let formatted = priceStr.slice(-3);
    let remaining = priceStr.slice(0, -3);
    
    // Разбиваем оставшуюся часть на группы по 2
    while (remaining.length > 2) {
      formatted = remaining.slice(-2) + ',' + formatted;
      remaining = remaining.slice(0, -2);
    }
    
    // Добавляем оставшиеся цифры (1-2 цифры)
    if (remaining.length > 0) {
      formatted = remaining + ',' + formatted;
    }
    
    return `${formatted} ${currencyName}`;
  }

  // Стандартное форматирование для остальных валют: группы по 3 цифры
  // Используем toLocaleString для правильного форматирования с разделителями тысяч
  // Округляем до целого числа для большинства валют (кроме тех, где нужны копейки)
  const formattedPrice = Math.round(roundedPrice).toLocaleString('en-US');
  return `${formattedPrice} ${currencyName}`;
}
